var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from 'react';
import { Input } from '@citrus/input';
import { DraftailEditor, BLOCK_TYPE, INLINE_STYLE } from 'draftail';
import { getDebug } from '@citrus/runtime';
import { removeKeys } from '@pcty/utils';
import 'draft-js/dist/Draft.css';
import 'draftail/dist/draftail.css';
import '../css/index.css';
var VERSION = '2.2.2-CDS3392.0';
var BLOCK_TYPES = [
    { type: BLOCK_TYPE.UNORDERED_LIST_ITEM, icon: React.createElement("i", { className: "pcty-icon pcty-input-icon-wysiwyg-unordered-list" }) },
    { type: BLOCK_TYPE.ORDERED_LIST_ITEM, icon: React.createElement("i", { className: "pcty-icon pcty-input-icon-wysiwyg-ordered-list" }) },
    { type: BLOCK_TYPE.CODE, element: 'code', icon: React.createElement("i", { className: "pcty-icon pcty-input-icon-wysiwyg-code" }) },
];
var INLINE_STYLES = [
    { type: INLINE_STYLE.BOLD, icon: React.createElement("i", { className: "pcty-icon pcty-input-icon-wysiwyg-bold" }) },
    { type: INLINE_STYLE.ITALIC, icon: React.createElement("i", { className: "pcty-icon pcty-input-icon-wysiwyg-italic" }) },
    // { type: INLINE_STYLE.STRIKETHROUGH },
    // { type: INLINE_STYLE.SUBSCRIPT },
    // { type: INLINE_STYLE.SUPERSCRIPT },
    { type: INLINE_STYLE.UNDERLINE, icon: React.createElement("i", { className: "pcty-icon pcty-input-icon-wysiwyg-underline" }) },
];
var Wysiwyg = React.forwardRef(function (_a, ref) {
    var additionalBlockTypes = _a.additionalBlockTypes, additionalInlineStyles = _a.additionalInlineStyles, automationId = _a.automationId, _b = _a.classNameWrapper, classNameWrapper = _b === void 0 ? '' : _b, css = _a.css, _c = _a.disabled, disabled = _c === void 0 ? false : _c, editorKey = _a.editorKey, _d = _a.emptyLabel, emptyLabel = _d === void 0 ? false : _d, errorMessage = _a.errorMessage, footnote = _a.footnote, _e = _a.hideOptionalLabel, hideOptionalLabel = _e === void 0 ? false : _e, id = _a.id, label = _a.label, _f = _a.labelAddOn, labelAddOn = _f === void 0 ? function () { return null; } : _f, _g = _a.labelPosition, labelPosition = _g === void 0 ? 'top' : _g, _h = _a.localization, localization = _h === void 0 ? 'en-US' : _h, onChange = _a.onChange, placeholder = _a.placeholder, _j = _a.rawContentState, rawContentState = _j === void 0 ? null : _j, _k = _a.required, required = _k === void 0 ? false : _k, _l = _a.showRequiredLabel, showRequiredLabel = _l === void 0 ? false : _l, _m = _a.showValidationState, showValidationState = _m === void 0 ? false : _m, _o = _a.toolbar, toolbar = _o === void 0 ? null : _o, _p = _a.valid, valid = _p === void 0 ? false : _p, _q = _a.__TYPE, TYPE = _q === void 0 ? 'Wysiwyg' : _q, other = __rest(_a, ["additionalBlockTypes", "additionalInlineStyles", "automationId", "classNameWrapper", "css", "disabled", "editorKey", "emptyLabel", "errorMessage", "footnote", "hideOptionalLabel", "id", "label", "labelAddOn", "labelPosition", "localization", "onChange", "placeholder", "rawContentState", "required", "showRequiredLabel", "showValidationState", "toolbar", "valid", "__TYPE"]);
    var classes = ['pcty-input-wysiwyg', !valid && showValidationState ? 'pcty-error' : '', disabled ? 'pcty-disabled' : '', other.className || '']
        .filter(function (x) { return x.length > 0; })
        .join(' ');
    var undo = !!((!!toolbar && toolbar.length > 0 && toolbar.indexOf('undo') > -1) || !toolbar);
    var redo = !!((!!toolbar && toolbar.length > 0 && toolbar.indexOf('redo') > -1) || !toolbar);
    var otherProps = removeKeys(other, ['id', 'className']);
    var _other = !automationId
        ? otherProps
        : __assign(__assign({}, otherProps), { 'data-automation-id': automationId });
    return (React.createElement(Input, { automationId: automationId, className: classNameWrapper, css: css, emptyLabel: emptyLabel, errorMessage: errorMessage, footnote: footnote, hideOptionalLabel: hideOptionalLabel, id: id, label: label, labelAddOn: labelAddOn, labelPosition: labelPosition, localization: localization, ref: ref, required: required, showRequiredLabel: showRequiredLabel, showValidationState: showValidationState, valid: valid },
        React.createElement("div", __assign({ className: classes, id: id }, _other),
            React.createElement(DraftailEditor, __assign({}, getDebug(sessionStorage.getItem('citrus-debug') === 'true', TYPE, VERSION), (editorKey ? { key: editorKey } : ''), { blockTypes: getBlockTypes(toolbar, additionalBlockTypes), inlineStyles: getInlineStyles(toolbar, additionalInlineStyles), onBlur: function () { return undefined; }, onSave: onChange, placeholder: placeholder, rawContentState: rawContentState, showRedoControl: redo, showUndoControl: undo, 
                // #### Save for future use ####
                // entityTypes={[
                //   {
                //     type: ENTITY_TYPE.LINK,
                //     source: () => (<h3>Do magic here to create a link!</h3>),
                //     icon: (<i className=".pcty-input-wysiwyg .pcty-input-icon-wysiwyg-link" />)
                //   },
                // ]}
                spellCheck: true })))));
});
var getInlineStyles = function (toolbar, inlineStyles) {
    var map = {
        bold: INLINE_STYLES[0],
        italic: INLINE_STYLES[1],
        underline: INLINE_STYLES[2],
    };
    if (inlineStyles && inlineStyles.length) {
        inlineStyles.map(function (item) {
            map = __assign(__assign({}, map), item);
        });
    }
    if (!toolbar || toolbar.length <= 0) {
        return INLINE_STYLES;
    }
    return toolbar.reduce(function (output, x) {
        if (map[x]) {
            return __spreadArray(__spreadArray([], output, true), [map[x]], false);
        }
        return output;
    }, []);
};
var getBlockTypes = function (toolbar, blockTypes) {
    var map = {
        'unordered-list': BLOCK_TYPES[0],
        'ordered-list': BLOCK_TYPES[1],
        code: BLOCK_TYPES[2],
    };
    if (blockTypes && blockTypes.length) {
        blockTypes.map(function (item) {
            map = __assign(__assign({}, map), item);
        });
    }
    if (!toolbar || toolbar.length <= 0) {
        return BLOCK_TYPES;
    }
    return toolbar.reduce(function (output, x) {
        if (map[x]) {
            return __spreadArray(__spreadArray([], output, true), [map[x]], false);
        }
        return output;
    }, []);
};
Wysiwyg.defaultProps = {
    __TYPE: 'Wysiwyg',
};
export default Wysiwyg;
